/*
 * Репозиторий доступных для выбора городов
 */

import Vue from 'vue';
import { dataAdapterCities, dataAdapterCountry } from '../helpers/data-adapter-cities';

const _ = require('lodash');
const axios = require('axios');

const CITIES_API_URL = citiesApiUrl;// eslint-disable-line

let loadPromise;

const repository = Vue.observable({
  cities: [],
  countries: [],
  isLoaded: false,
});
window.repository = repository;

export const getters = {
  cities: () => repository.cities,
  countries: () => repository.countries,
};

export const actions = {
  sort(collection, prop) {
    return _.chain(collection).sortBy(prop).value();
  },
  load() {
    if (!this.isLoaded) {
      this.isLoaded = true;
      loadPromise = this
        .fetch()
        .then((resp) => {
          repository.cities = resp.cities;
          repository.countries = dataAdapterCountry(resp.cities, resp.country);
        });
    }

    return loadPromise;
  },
  fetch() {
    return new Promise((resolve) => {
      axios
        .get(CITIES_API_URL + '/list')
        .then((result) => {
          if (result && result.data && result.data.cities) {
            const { cities } = result.data;
            const { country } = result.data;

            resolve({ cities: dataAdapterCities(cities), country });
          }
        });
    });
  },
  search(q) {
    return _.filter(repository.cities, (v) => (v.Name.toLowerCase().includes(q.toLowerCase())));
  },
  find(cityCode) {
    return _.filter(repository.cities, (v) => (v.Code === cityCode));
  },
  filter(collection, sign) {
    return _.filter(collection, (v) => (v[`${sign}`] === true));
  },
};
